<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
            <v-breadcrumb value1="首页" value2="了解廉江" value3="音画廉江" :url="url"></v-breadcrumb>
            <div class="container_box">
                <!--<div class="box_top">
                    <span >廉江动态</span>丨<span> 最热 </span>丨<span> 最新 </span>丨<span> 精华 </span>
                </div>-->

                <div class="box_item mt20" v-for="i in dataList" @click="showVr(i)">
                    <img class="i" :src="i.coverImageUrl">
                    <div class="right_down hover" >

                        <img src="../../assets/img/ljlj/mp4.png">  {{i.title}}


                    </div>
                    <div class="cover hover">
                        <img src="../../assets/img/ljlj/play.png">

                    </div>


                </div>



            </div>



        </div>

        <div class="vr" v-if="show" >
            <div class="vr-list">
                <div class="title">
                    <img src="../../assets/img/ljlj/close.png" @click="closeVr">

                </div>
                <div class="mp4">
                    <video v-if="vr.href" class="content" :src="vr.href" autoplay="autoplay" style="width: 1000px;height: 563px;margin: 0 auto;margin-top: 100px" controls="controls" object-fit="cover">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>

            </div>

        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                fullscreenLoading:false,
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                url:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'廉江概览',
                        url:'#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cabebd0006'
                    },
                    {
                        name:'廉江动态',
                        url:'#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91caf27c0007'
                    },
                    {
                        name:'节庆活动',
                        url:'#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb31640008'
                    },
                    {
                        name:'音画廉江',
                        url:'#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb9d910009'
                    }
                ],
                show:false,
                vr:{href:''
                }

            }
        },
        watch:{
            show:function (newValue) {
                console.log(newValue)
                if(newValue){
                    document.body.style.overflow = 'hidden'
                }else {
                    document.body.style.overflow = ''
                }
            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = [this.ljcode,this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            closeVr(){
                this.show = false;
            },
            showVr(v){
                this.vr.href = v.href;
                this.show = true;
            },
            getList(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=20&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;

                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        v.time = that.common.date2Local(v.createDate);
                    });
                    this.dataList = data;
                    console.log(data);
                })
            },
            toDetail(v){
                this.$router.push({path:`/detail2?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/ljlj/lake.png");
    }
    .container_box{
        display: flex;
        flex-wrap: wrap;
        .box_item{
            height: 277px;
            width: 360px;
            border-radius:4px;
            margin-bottom: 20px;
            position: relative;
            margin-right: 20px;
            .i{
                width: 360px;
                height: 237px;
            }
            .right_down{
                width: 100%;
                position: absolute;
                bottom: 0;
                height: 20px;
                line-height: 20px;
                text-align: left;
                font-size:14px;
                img{
                    position: relative;
                    top: 2px;
                    margin-right: 10px;
                }
            }
            .cover{
                width: 360px;
                height: 237px;
                background: rgba(0,0,0,0.4);
                position: absolute;
                top: 0;
                text-align: center;
                img{
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

        }

    }

    .vr{
        z-index:999;
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100vw;
        display: flex;
        background: rgba(0,0,0,0.7);
        .vr-list{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                height: 70px;
                line-height: 70px;
                position: relative;
                text-align: left;
                font-size: 25px;
                color: white;
                padding-left: 40px;
                width: 100%;
                img{
                    position: absolute;
                    right: 50px;
                    width: 70px;
                    height: 70px;
                    z-index: 9999;
                }
            }
            .detail{
                width: 80%;
                flex: 1;
                overflow-y: scroll;
                height: 0;
                .detail_item{
                    margin: 0 auto;
                    height: 190px ;
                    width: 288px;
                    position: relative;
                    margin-bottom: 20px;
                    .detail_bottom{
                        position: absolute;
                        bottom: 0;
                        height: 40px;
                        line-height: 40px;
                        background: rgba(0,0,0,0.4);
                        color: white;
                        font-size: 20px;
                        width: 100%;
                        padding-left: 20px;
                    }
                }
                .active{
                    border: 8px solid rgb(252,101,0);
                }
            }
        }
    }


</style>
<style>

    .detail::-webkit-scrollbar {/*滚动条整体样式*/

        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/

        height: 1px;


    }

    .detail::-webkit-scrollbar-thumb {/*滚动条里面小方块*/


        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

        background: rgb(255,102,0);

    }

    .detail::-webkit-scrollbar-track {/*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);


        background: rgb(26,26,26);

    }
</style>
